import React, { forwardRef } from 'react';
import styled, { css } from 'styled-components';

import isMobile from '~/utils/is-mobile';

import font from '~/styled/font';
import btnStd from '~/styled/button';

function hover(color) {
  if (isMobile.any()) return '';
  return css`
    &:hover {
      background-color: ${color};
    }
  `;
}

function getColor(color) {
  switch (color) {
    case 'blue':
      return css`
        background-color: #326CF9;
        ${hover('#1E41D0')};
      `;

    case 'red':
      return css`
        background-color: #E20724;
        ${hover('#A9051A')};
      `;

    case 'gray':
      return css`
        background-color: #222222;
        ${hover('#434343')};
      `;
  }

  return '';
}

function getSize(size) {
  switch (size) {
    case 'sm':
      return css`
        height: 28px;
        ${font.caption1};
      `;

    case 'md':
      return css`
        height: 36px;
        ${font.body3};
      `;

    case 'lg':
      return css`
        height: 44px;
        ${font.body3};
      `;

    case 'xl':
      return css`
        height: 56px;
        ${font.body3};
      `;
  }

  return '';
}

const SolidButton = styled.button`
  ${btnStd};
  width: ${({ contentWidth }) => contentWidth};
  padding: 0 16px;
  color: #FFFFFF;
  font-weight: 700;
  
  > svg + span,
  > span + svg{
    margin-left: 4px;
  }
  
  ${({ btnColor }) => getColor(btnColor)};
  ${({ btnSize }) => getSize(btnSize)};

  &:disabled {
    background-color: #DFDFDF;

    > svg {
      path,
      circle,
      rect {
        fill: #FFFFFF !important;
      }
    }
  }
`;

const SolidButtonComponent = forwardRef(({
  contentWidth = 'auto',
  btnColor,
  btnSize,
  children,
  ...props
}, ref) => {
  return (
    <SolidButton
      {...props}
      ref={ref}
      btnColor={btnColor}
      btnSize={btnSize}
      contentWidth={contentWidth}
    >
      <span>{children}</span>
    </SolidButton>
  );
});

export default SolidButtonComponent;
